export const BRANCHES = {
  main: { label: "Sede principal", canton: "QUITO" },
  // guayaquil: { label: "Sucursal Guayaquil", canton: "Guayaquil" },
} as const;

export type BranchKey = keyof typeof BRANCHES;

// branch vacío = sede principal. Si trae un valor que no existe, devuelve null para que la pantalla avise.
export function getCantonByBranch(branch?: string | null): string | null {
  if (!branch) return BRANCHES.main.canton;
  return branch in BRANCHES ? BRANCHES[branch as BranchKey].canton : null;
}